import request from '@/utils/request'

export function findEsimGoods(params) {
  return request({
    url: `/customer/esim_goods`,
    method: 'get',
    params
  })
}

export function findEsimGoodsInfo(id, params) {
  return request({
    url: `/customer/esim_goods/${id}`,
    method: 'get',
    params
  })
}
